import React, { FC, useMemo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LinkProps } from '../../hooks/useLinks';
import { cn } from '../../utils/classNames';

export const Link: FC<LinkProps> = ({ to, icon, label }) => {
  const location = useLocation();
  const isActive = useMemo(
    () => location.pathname.startsWith(to),
    [location.pathname, to],
  );

  return (
    <NavLink
      to={to}
      className={cn(
        'text-inherit flex cursor-pointer items-center gap-[20px] rounded mx-2 px-[14px] py-[14px] duration-100 active:scale-[0.97] active:bg-white/20 bg-white/15 backdrop-blur',
        isActive && 'bg-white/50 backdrop-blur shadow-sm',
      )}
    >
      <span className="[&>svg]:size-5">{icon}</span>
      <span className={cn('text-left', isActive && 'font-bold')}>{label}</span>
    </NavLink>
  );
};

export default Link;
